import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
// Lazy boundary: QR rendering is only needed on the deposit/withdraw/connect
// steps that actually show a code, but `react-qrcode-logo` (qrcode + canvas
// machinery) is heavy enough to matter in the synchronous widget bundle. The
// dynamic import keeps it in an async chunk fetched at first QR render; every
// call site keeps importing this module unchanged.
const StyledQRCodeImpl = lazy(() => import("./StyledQRCodeImpl"));
const StyledQRCode = (props) => {
    const size = props.size ?? 140;
    return (_jsx(Suspense, { fallback: _jsx("div", { style: { width: size, height: size }, "aria-hidden": "true" }), children: _jsx(StyledQRCodeImpl, { ...props }) }));
};
export default StyledQRCode;
